<template>
  <validation-observer
    vid="stepVehicleInfoForm"
    ref="stepVehicleInfoForm"
    tag="div"
    novalidate
  >
    <vvs-control-wrapper
      label="3. Araç Bilgileri"
      description="Başvurunuzu tamamlayabilmeniz için en az 1 adet araç bilgisi eklemek zorundasınız."
    ></vvs-control-wrapper>

    <div class="vehicles">
      <div
        v-for="(vehicle, index) in step.vehicles"
        :key="index"
        :id="`vehicle-item-${index}`"
        class="vehicle-item"
      >
        <h3 class="vehicle-title">{{ index + 1 }}. Araç</h3>
        <vvs-select
          name="Araç Tipi"
          label="Araç Tipi"
          validate="required"
          :options="vehicleTypes"
          v-model="vehicle.type"
          normal-label
          return-object
        ></vvs-select>
        <div class="vehicle-row">
          <div class="vehicle-cell">
            <vvs-input
              name="Marka"
              label="Marka"
              placeholder="Aracın Markası"
              validate="required|min:3|max:255"
              v-model="vehicle.brand"
              normal-label
            ></vvs-input>
          </div>
          <div class="vehicle-cell">
            <vvs-input
              name="Model"
              label="Model"
              placeholder="Aracın Modeli"
              validate="required|min:3|max:255"
              v-model="vehicle.model"
              normal-label
            ></vvs-input>
          </div>
        </div>
        <div class="vehicle-row">
          <div class="vehicle-cell">
            <vvs-select
              name="Yıl"
              label="Yıl"
              validate="required"
              :options="vehicleYears"
              v-model="vehicle.year"
              normal-label
            ></vvs-select>
          </div>
          <div class="vehicle-cell">
            <vvs-input
              name="Hacim (m3)"
              label="Hacim (m3)"
              placeholder="Aracınızın m3 cinsinden yük hacmi"
              validate="numeric|min_value:1|max_value:1000"
              v-model="vehicle.volume"
              normal-label
            ></vvs-input>
          </div>
        </div>
        <div class="text-right">
          <a
            href="#"
            class="vehicle-button"
            v-text="'(-) Aracı Kaldır'"
            @click.prevent="removeVehicle(index)"
          ></a>
        </div>
      </div>

      <div class="text-left">
        <a
          href="#"
          class="vehicle-button vehicle-button-large"
          v-text="'(+) Yeni araç Ekle'"
          @click.prevent="addVehicle({ scroll: true })"
        ></a>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepVehicleInfo',
  mixins: [stepsMixin],
  computed: {
    vehicleTypes() {
      return [
        {
          id: 'lightCommercialVehicle',
          name: 'Hafif Ticari Araç',
        },
        {
          id: 'van',
          name: 'Kamyonet',
        },
        {
          id: 'truck',
          name: 'Kamyon',
        },
      ];
    },
    vehicleYears() {
      const maxYear = new Date().getFullYear();
      const minYear = 1985;
      let years = [];

      for (let i = maxYear; i >= minYear; i--) years.push(i);

      return years;
    },
  },
  methods: {
    addVehicle({ scroll = false }) {
      this.step.vehicles.push({
        type: null,
        brand: null,
        model: null,
        year: null,
        volume: null,
      });

      if (scroll) {
        this.$nextTick(() => {
          this.$scrollTo(`#vehicle-item-${this.step.vehicles.length - 1}`, {
            offset: -50,
          });
        });
      }
    },
    removeVehicle(index) {
      this.step.vehicles.splice(index, 1);
      this.$nextTick(() => {
        this.setVehicles();

        this.$nextTick(() => {
          this.$scrollTo(`#vehicle-item-${this.step.vehicles.length - 1}`, {
            offset: -50,
          });
        });
      });
    },
    setVehicles() {
      if (this.step.vehicles.length === 0) {
        this.addVehicle({});
      }
    },
  },
  created() {
    this.setVehicles();
  },
};
</script>

<style lang="scss">
.vehicles {
  .vehicle-item {
    background-color: #fcfcfc;
    border: 1px solid #eee;
    padding: 10px;
    margin-top: 20px;
    border-radius: 5px;
    text-align: left;

    &:first-child {
      margin-top: 0;
    }
  }

  .vehicle-title {
    width: 100%;
    text-align: left;
    font-family: BrandonTextBold;
    font-size: 15px;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 1.78px;
    color: #40484e;
    margin: 0 auto 15px;
  }

  .vehicle-row {
    display: flex;
    flex-direction: row;

    .vehicle-cell {
      flex: 1 0 0;
      margin: 0 5px;

      &:first-child {
        margin-left: 0px;
      }
      &:last-child {
        margin-right: 0px;
      }
    }
  }

  .vehicle-button {
    display: inline-block;
    font-family: 'BrandonTextRegular';
    color: #40484e;
    font-size: 13px;
    margin: 0 auto;
    text-decoration: none;

    &:hover {
      color: #111;
    }

    &.vehicle-button-large {
      font-size: 15px;
      margin-top: 15px;
    }
  }

  @media (max-width: 767px) {
    .vehicle-row {
      flex-direction: column;
    }
    .vehicle-cell {
      margin: 0 !important;
    }
  }
}
</style>
